export default __webpack_public_path__ + "dot.acf2d3043017a024.svg";